import { render } from "./staff.vue?vue&type=template&id=14e6fa17&scoped=true&ts=true"
import script from "./staff.vue?vue&type=script&lang=ts"
export * from "./staff.vue?vue&type=script&lang=ts"

import "./staff.vue?vue&type=style&index=0&id=14e6fa17&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e6fa17"]])

export default __exports__